import React, { useState, useEffect } from "react";
import ResizeListener from "../../../../../utility/ResizeListener";
import { useLocation, useNavigate } from "react-router";
import TopHeaderComponent from "../../../../components/TopHeaderComponent";
import BodyComponent from "../../../../components/BodyComponent";
import { WHITE_COLOR } from "../../../../resources/colorsManager";
import BeneficairyBasicDetails from "./BasicDetails";
import BeneficiaryTransaction from "./BeneficiaryTransaction";

function BeneficiaryDetailsIndex() {
  const { width, height } = ResizeListener();
  const [step, setStep] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();
  const [bankDetails, setBankDetails] = useState([]);
  const pStyle = {
    fontSize: 15,
    fontWeight: "bold",
    fontFamily: "Roboto",
    cursor: "pointer",
  };

  useEffect(() => {}, [location]);
  return (
    <BodyComponent style={{ width: "100%" }}>
      <TopHeaderComponent
        headerName={location?.state?.beneficiaryName}
        isSearchRequired={false}
        inputStyle={{
          width: width * 0.3,
          minWidth: 300,
        }}
        placeholder="Search Transaction ID...."
        onClickBack={() => {
          navigate(-1);
          // navigate("/customers", {
          //   state: {
          //     isBackToBeneficiaryTab: true,
          //   },
          // });
        }}
        showFilter={false}
        showDownload={false}
        isOnClickBack={true}
      />
      <div
        style={{
          width: "100%",
          display: "flex",
          backgroundColor: WHITE_COLOR,
          marginTop: 20,
          borderRadius: 15,
          flexDirection: "column",
          height: width > 1000 ? "auto" : "100%",
        }}
      >
        <div
          style={{
            width: "100%",
            padding: 10,
            borderBottom: "1px solid #C4C4C4",
          }}
        >
          <div
            style={{
              display: "flex",
              minWidth: 100,
              maxWidth: 200,
              justifyContent: "space-between",
              marginLeft: 20,
            }}
          >
            <p
              style={{
                ...pStyle,
                color: step === 0 ? "black" : "#8F8F8F",
              }}
              onClick={() => setStep(0)}
            >
              Basic Details
            </p>
            <p
              style={{
                ...pStyle,
                color: step === 1 ? "black" : "#8F8F8F",
              }}
              onClick={() => setStep(1)}
            >
              Transactions
            </p>
          </div>
        </div>

        <div
          style={{
            width: "100%",
            padding: "20px 0px",
            maxHeight: height * 0.55,
            overflow: "auto",
          }}
        >
          {step === 0 ? (
            <>
              <BeneficairyBasicDetails details={location?.state} />
            </>
          ) : step === 1 ? (
            <>
              <BeneficiaryTransaction details={location?.state} />
            </>
          ) : null}
        </div>
      </div>
    </BodyComponent>
  );
}

export default BeneficiaryDetailsIndex;
